import { Stack, Text } from "flicket-ui";
import AnimatedLoadingSpinner from "~features/single-page-checkout/components/AnimatedLoadingSpinner/AnimatedLoadingSpinner";

interface LockingInPriceSpinnerProps {
  isLoading: boolean;
  onAnimationComplete: () => void;
}

export function LockingInPriceSpinner({
  isLoading,
  onAnimationComplete,
}: LockingInPriceSpinnerProps) {
  function handleAnimationComplete() {
    // Delay the callback to avoid jarring transitions.
    setTimeout(onAnimationComplete, 200);
  }

  return (
    <Stack
      direction="vertical"
      gap={1}
      alignItems="center"
      justifyContent="center"
      height="386px"
      padding={1}
    >
      <Text variant="header.M" textAlign="center">
        Locking in your best price...
      </Text>
      <AnimatedLoadingSpinner
        loading={isLoading}
        onComplete={handleAnimationComplete}
      />
    </Stack>
  );
}
